'use client';

import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { Spacers } from '@styles/theme';

export const LandingPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.LG}rem;
  justify-content: flex-start;
  height: calc((100vh - (100vh - 100%)) - (var(--desktop-gutter) * 2));
  width: calc((100vw - (100vw - 100%)) - (var(--mobile-gutter) * 2));

  ${breakpoints.desktopOrBigger} {
    justify-content: center;
  }
`;

// Styles for landing page navigation
export const NavigationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.SM}rem;
  margin-bottom: ${Spacers.LG}rem;
  margin-top: auto;

  ${breakpoints.desktopOrBigger} {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacers.SM}rem;

  ${breakpoints.desktopOrBigger} {
    gap: ${Spacers.MD}rem;
  }
`;
